import React from 'react';
import { ModuleBridge } from '../components';
import { ViewMigrationsTopBar } from '../components/ViewMigrationsTopBar';

export const ArchivedMigrations = () => {
    return (
        <>
            <ViewMigrationsTopBar />
            <div id="archived_migrations_container"></div>
            <ModuleBridge moduleId="archived_migrations_main" />
        </>
    );
};
